var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.8 48",
    style: {
      enableBackground: "new 0 0 48.8 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#29AAE1;}\r\n\t.st1{fill:#EC2427;}\r\n\t.st2{fill:#0D73BB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "33.3,19.2 23.8,19.3 23.8,5.2 33.3,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "48.8,48 39.3,48 39.3,5.2 48.8,0  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.9,44.7C1.2,42.1,0,38.5,0,33.6c0-4.8,1.2-8.5,3.9-11c1.9-1.8,4.6-3.2,9.8-3.2l19.6-0.1l-9.6,9.6h-9.6 c-2,0-3,0.2-4,1c-1,0.8-1.7,1.5-1.7,3.8c0,2.4,0.7,3,1.7,3.9c1,0.8,2,1,4,1l19.2-0.1V48l-19.6-0.1C8.5,47.9,5.8,46.6,3.9,44.7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9dcdc0bf5298e39f6de58f8fe67bf063.svg";
export { ForwardRef as ReactComponent };